import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput, FormSwitch, FormTextArea } from '../../components/form/index.js';
import { useFeedbackContext } from '../../contexts/feedbacks/feedback.tsx';
import { Feedback } from '../../models/feedbacks/feedback.ts';
import FormatDate from '../../models/helpers/formatDate.ts';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    isSolved: Yup.boolean(),
});

const FeedbackBody = () => {
    const { id } = useParams();
    const {
        isLoaded,
        feedback,
        insertFeedback,
        updateFeedback
    } = useFeedbackContext();
    const [localFeedback, setLocalFeedback] = useState<Feedback>(feedback);
    useEffect(() => {
        setLocalFeedback(feedback);
    }, [feedback])
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setLocalFeedback((prevData) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...localFeedback, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(localFeedback, { abortEarly: false })
            .then(() => {
                setLocalFeedback(localFeedback);
                if (id == "create")
                    insertFeedback(localFeedback);
                else
                    updateFeedback(localFeedback);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };

    if (!isLoaded) return;
    return (
        <Form>
            {/* <FormSelect
                entity={localFeedback}
                handleInputChange={handleInputChange}
                options={feedbacks}
                fieldName='relationID'//TODO: should update relationID but the value from options is feedbackID
                label='Linked to'
                errors={errors}
            /> */}
            <FormInput
                entity={localFeedback}
                handleInputChange={handleInputChange}
                fieldName='name'
                label='Name'
                errors={errors} />
            <FormTextArea
                entity={localFeedback}
                handleInputChange={handleInputChange}
                fieldName='description'
                label='Description'
                rows={20}
                errors={errors} />
            {id != 'create' &&
                <FormSwitch
                    entity={localFeedback}
                    handleInputChange={handleInputChange}
                    fieldName='isSolved'
                    label='Is solved'
                />}
            {localFeedback.createDate &&
                <small className="text-muted display-block">
                    Created at: {FormatDate(localFeedback.createDate, 'dd-mm-yyyy hh:mm')}
                </small>
            }
            {localFeedback.updateDate &&
                <>
                    <br />
                    <small className="text-muted">
                        Last updated at: {FormatDate(localFeedback.updateDate, 'dd-mm-yyyy hh:mm:ss')}
                    </small>
                </>
            }
            {localFeedback.solvedDate &&
                <>
                    <br />
                    <small className="text-muted">
                        Solved at: {FormatDate(localFeedback.solvedDate, 'dd-mm-yyyy hh:mm:ss')}
                    </small>
                </>
            }
            <FormActions
                mainAction={handleSubmit}
                mainActionText={"Save"}
                showCancelButton
            />
        </Form>
    );
};

export default FeedbackBody;